// eslint-disable-next-line
const { name, version } = require('../../package.json');
export { name, version };
